import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const printschemes = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 1000,
            total: 0,
            page: 1,
            groupID: null,
        },
        selectedItems: [],
        loading: true,
        printForm: {
            participant: null,
            schemeID: null,
            reason: null,
            checkIn: false,
            modalVisible: false,
            validationErrors: [],
        },
    }),
    mutations: {
        setPrintSchemes(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.total;
        },
        setSelectedPrintSchemes(state, payload) {
            state.selectedItems = payload;
        },
        setPrintSchemePage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getPrintSchemes');
        },
        setPrintSchemeTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getPrintSchemes');
        },
    },
    actions: {
        async copyPrintScheme(store,payload){
            var res = await axios.post('PrintScheme/Copy', {id : payload});
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async getOnePrintScheme(store, payload) {
            var res = await axios.post('/PrintScheme/Get', {
                id: payload,
            });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            }
            return res;
        },
        async togglePrintSchemes(store, payload) {
            var res = await axios.post('/PrintScheme/toggleisactive', {
                id: payload,
            });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res.data;
        },
        async savePrintOrder(context, payload) {
            var res = await axios.post('/PrintScheme/UpdateOrderNos', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
        async initPrint(store, payload) {
            if (store.state.items.length == 0) {
                await store.dispatch('getPrintSchemes');
            }
            store.state.printForm.participant = payload;
            store.state.printForm.modalVisible = true;
        },
        async printCard(store, payload) {
            await axios
                .post('participant/print', {
                    ...store.state.printForm,
                    id: store.state.printForm.participant.id,
                })
                .then((res) => {
                    store.state.printForm.validationErrors = res.data.validationErrors;
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        payload.context.$message.success(res.data.alert.message);
                        store.state.printForm.participant = null;
                        store.state.printForm.reason = null;
                        store.state.printForm.modalVisible = false;
                    }
                });
        },
        async getPrintSchemes(store) {
            store.state.loading = true;
            var res = await axios.post('printscheme/list', {
                ...store.state.filter,
                skip: (store.state.filter.page - 1) * store.state.filter.take,
            });

            store.state.loading = false;
            return store.commit('setPrintSchemes', res.data.data);
        },
        async togglePrintScheme(store, payload) {
            var res = await axios.post('speaker/toggleisactive', {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async deletePrintScheme(store, payload) {
            var res = await axios.post('printscheme/delete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
    },
    getters: {},
};
export default printschemes;


// WEBPACK FOOTER //
// ./src/store/printschemes.js